import React, { useState, useEffect } from 'react';
import { FiPlus, FiEdit2, FiTrash2, FiCornerDownRight } from 'react-icons/fi';
import { api } from '../api';
import { useMe } from '../App';
import { findPerm } from '../perm';

export default function Brands() {
  const me = useMe();
  const perm = findPerm(me.modules, 'brands');
  const [rows, setRows] = useState(null);
  const [modal, setModal] = useState(null);
  const [toast, setToast] = useState('');

  async function load() { try { setRows(await api('/brands')); } catch (e) { setToast(e.message); } }
  useEffect(() => { load(); }, []);
  function flash(m) { setToast(m); setTimeout(() => setToast(''), 2600); }

  async function remove(b) {
    if (!window.confirm(`Delete "${b.name}"?`)) return;
    try { await api('/brands/' + b.id, { method: 'DELETE' }); flash('Brand deleted'); load(); }
    catch (e) { flash(e.message); }
  }

  const parents = rows ? rows.filter((b) => !b.parent_id) : [];

  return (
    <div>
      <div className="mod-head">
        <div className="titles">
          <div className="page-eyebrow">Configuration</div>
          <h1>Brands</h1>
          <div className="count">{rows ? `${rows.length} brand${rows.length !== 1 ? 's' : ''} (incl. sub-brands)` : 'Loading…'}</div>
        </div>
        {perm.can_create && (
          <button className="btn btn-dark" onClick={() => setModal({ mode: 'add', brand: {} })}><FiPlus /> Add brand</button>
        )}
      </div>

      <div className="table-card">
        {!rows ? <div className="empty">Loading…</div> :
         rows.length === 0 ? <div className="empty"><h3>No brands yet</h3><p>Add your first brand.</p></div> :
          <table className="data">
            <thead><tr>
              <th>Brand</th><th>Campaigns</th>
              {(perm.can_edit || perm.can_delete) && <th style={{ textAlign: 'right' }}>Actions</th>}
            </tr></thead>
            <tbody>
              {parents.map((p) => {
                const kids = rows.filter((b) => b.parent_id === p.id);
                return (
                  <React.Fragment key={p.id}>
                    <BrandRow b={p} perm={perm} onEdit={(x) => setModal({ mode: 'edit', brand: x })} onDelete={remove} />
                    {kids.map((k) => <BrandRow key={k.id} b={k} sub perm={perm}
                      onEdit={(x) => setModal({ mode: 'edit', brand: x })} onDelete={remove} />)}
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>}
      </div>

      {modal && <BrandModal {...modal} parents={parents}
        onClose={() => setModal(null)} onSaved={(m) => { setModal(null); flash(m); load(); }} />}
      {toast && <div className="toast">{toast}</div>}
    </div>
  );
}

function BrandRow({ b, sub, perm, onEdit, onDelete }) {
  return (
    <tr>
      <td style={{ fontWeight: sub ? 400 : 600, paddingLeft: sub ? 40 : undefined }}>
        {sub && <FiCornerDownRight style={{ verticalAlign: '-2px', marginRight: 7, color: 'var(--brass)' }} />}
        {b.name}
      </td>
      <td><span className="pill pill-muted">{b.campaign_count}</span></td>
      {(perm.can_edit || perm.can_delete) && (
        <td><div className="row-actions">
          {perm.can_edit && <button className="btn btn-sm" onClick={() => onEdit(b)}><FiEdit2 /></button>}
          {perm.can_delete && <button className="btn btn-sm btn-danger" onClick={() => onDelete(b)}><FiTrash2 /></button>}
        </div></td>
      )}
    </tr>
  );
}

function BrandModal({ mode, brand, parents, onClose, onSaved }) {
  const [name, setName] = useState(brand.name || '');
  const [parent_id, setParent] = useState(brand.parent_id || '');
  const [error, setError] = useState(''); const [busy, setBusy] = useState(false);

  async function save() {
    setError(''); setBusy(true);
    const body = { name, parent_id: parent_id || null };
    try {
      if (mode === 'add') { await api('/brands', { method: 'POST', body }); onSaved('Brand added'); }
      else { await api('/brands/' + brand.id, { method: 'PUT', body }); onSaved('Brand updated'); }
    } catch (e) { setError(e.message); setBusy(false); }
  }

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h2>{mode === 'add' ? 'Add brand' : 'Edit brand'}</h2>
        <div className="field"><label>Brand name</label>
          <input value={name} autoFocus onChange={(e) => setName(e.target.value)} placeholder="e.g. SmartBoard or TriLuxe" /></div>
        <div className="field"><label>Parent brand (leave blank for a top-level brand)</label>
          <select value={parent_id} onChange={(e) => setParent(e.target.value)}>
            <option value="">— None (top-level brand) —</option>
            {parents.filter((p) => p.id !== brand.id).map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
          </select></div>
        {error && <div className="inline-error">{error}</div>}
        <div className="modal-actions">
          <button className="btn" onClick={onClose} disabled={busy}>Cancel</button>
          <button className="btn btn-dark" onClick={save} disabled={busy || !name.trim()}>{busy ? 'Saving…' : 'Save'}</button>
        </div>
      </div>
    </div>
  );
}
